import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { AdminNavEntryPointV3 } from '@retailer-platform/dashboard/routing'
import { customersAndOrdersAdminRouter } from './routing/customersAndOrdersAdminRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { CustomersAndOrdersViewAccessControl } from './access-control/customersAndOrdersAdminAccess.configuration'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'customers-and-orders',
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'customers-and-orders-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  lazyTranslations: {
    ES_ES: () => import('./translations/es-ES.json'),
    FR_FR: () => import('./translations/fr-FR.json'),
  },
  routers: {
    admin: [customersAndOrdersAdminRouter],
  },
  navigationEntries: [],
  adminNavigationEntries: [
    {
      attachToV3: AdminNavEntryPointV3.CustomersAndOrders,
      subNavItems: [
        {
          route: 'app-admin-customers-and-orders-ipp-customer-search',
          labelId: 'customersAndOrdersDomain.admin.customersAndOrders.title',
          accessControl: CustomersAndOrdersViewAccessControl,
          subRoutes: [
            'app-admin-customers-and-orders-ipp-customer-details',
            'app-admin-customers-and-orders-ipp-customer-orders-list',
            'app-admin-customers-and-orders-ipp-customer-order-details',
            'app-admin-customers-and-orders-ipp-customer-order-history',
            'app-admin-customers-and-orders-dashboard-wildcard',
          ],
        },
      ],
    },
  ],
  // NOTE TO DEV: run `pnpm ipp domain register <your-system-name>` to register your domain with Totem here
}

export default definition
